import { PersonAdd, RemoveCircle, UserIconFilled } from '@/components/icons'
import { ROUTE_PLAYER_PROFILE } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { PlayerOfTeam } from '@/types'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { eventSelector } from '../selectors'
import { BracketMatchAddParticipantModal } from './BracketMatchAddParticipantModal'

type Props = {
  player: PlayerOfTeam
  isWinner?: boolean
  subPlayers: any
  removePlayer: (id: any) => void
  excludeData: any
  handleAddPlayer: (player: any) => void
}

export const PlayerButton = ({ player, isWinner, subPlayers, removePlayer, excludeData, handleAddPlayer }: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { bracket } = useAppSelector(eventSelector)

  const [addPartner, setAddPartner] = useState(false)

  const openAddPartnerModal = () => setAddPartner(true)

  const closeAddPartnerModal = () => setAddPartner(false)

  const onNavigateProfile = (playerId: number) => navigate(`${ROUTE_PLAYER_PROFILE}/${playerId}`)

  const subPlayer = subPlayers?.filter((item: any) => item?.playerId === player.id)
  const checkSub = subPlayer?.[0]?.isPlayerSubstituted
  const checkId = subPlayer?.[0]?.subPlayerId
  const allowSubstitution = subPlayer?.[0]?.allowSubstitution

  return (
    <>
      <div>
        {!checkId && checkSub ? (
          <div
            className="flex items-center cursor-pointer gap-x-4 border py-3 px-4 my-2 rounded"
            onClick={openAddPartnerModal}
          >
            <PersonAdd className="text-primary-500" />
            <span className="text-primary-500 font-semibold text-sm">{t('event.addParticipant')}</span>
          </div>
        ) : (
          <div
            className={`flex items-center cursor-pointer transition-all duration-300 ease-in-out ${
              !isEmpty(subPlayers) ? 'border p-4 my-2 rounded relative' : 'py-1 border-none'
            }`}
            onClick={() => {
              if (!checkSub) onNavigateProfile(player.id)
            }}
          >
            {!isEmpty(subPlayers) && allowSubstitution && (
              <button
                className="absolute -top-2 -right-2"
                onClick={(e) => {
                  e.stopPropagation()
                  removePlayer(player.id)
                }}
              >
                <RemoveCircle />
              </button>
            )}
            {checkSub ? (
              <>
                {subPlayer?.[0]?.subPlayerImageUrl ? (
                  <img src={subPlayer?.[0]?.subPlayerImageUrl} className="w-4 h-4 rounded-full" alt="" />
                ) : (
                  <UserIconFilled className="w-4 h-4 text-primary-500" />
                )}
              </>
            ) : (
              <>
                {player?.imageUrl ? (
                  <img src={player?.imageUrl} className="w-4 h-4 rounded-full" alt="" />
                ) : (
                  <UserIconFilled className="w-4 h-4 text-primary-500" />
                )}
              </>
            )}
            <span className={`ml-2 text-xs text-navy-900 ${isWinner ? '' : 'text-opacity-50'} font-medium`}>
              {checkSub ? subPlayer?.[0]?.subPlayerFullName : player?.fullName}
            </span>
          </div>
        )}
      </div>
      {bracket && (
        <BracketMatchAddParticipantModal
          open={!!addPartner}
          onClose={closeAddPartnerModal}
          onSubmit={(value) => handleAddPlayer(value)}
          excludeData={excludeData}
        />
      )}
    </>
  )
}
